// extracted by mini-css-extract-plugin
export default {"name_source":"RecipeNameSource_name_source__1NmZv","recipe_name":"RecipeNameSource_recipe_name__05UZ9"};